module.exports = __webpack_public_path__ + "img/bt.65b20c56.svg";